export class SchoolType {
  static PUBLIC = "public"
  static PRIVATE = "private"
  static FOR_PROFIT = "for_profit"

  constructor(value) {
    this.value = value
  }

  label() {
    return {
      [SchoolType.PUBLIC]: "Public",
      [SchoolType.PRIVATE]: "Private",
      [SchoolType.FOR_PROFIT]: "For-Profit",
    }[this.value]
  }
}
